import { render } from "./ModalForms.vue?vue&type=template&id=5a8b1d68&scoped=true"
import script from "./ModalForms.vue?vue&type=script&lang=js"
export * from "./ModalForms.vue?vue&type=script&lang=js"

import "./ModalForms.vue?vue&type=style&index=0&id=5a8b1d68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8b1d68"]])

export default __exports__